<label [for]="name" class="form-label">{{name | translate}}</label>
<input [id]="name" type="text" class="form-control"/>